var _defs, _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThreeVerticalDots = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 29.96 122.88"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "3-vertical-dots")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Zm0,92.93a15,15,0,1,1-15,15,15,15,0,0,1,15-15Zm0-46.47a15,15,0,1,1-15,15,15,15,0,0,1,15-15Z"
})));
export { SvgThreeVerticalDots as ReactComponent };
export default __webpack_public_path__ + "static/media/threeVerticalDots.2b9d327dccb65150ac7f35cce9ae16d2.svg";